<template>
  <div v-if="userForm && userForm.user">
    <!-- <b-alert
                v-show="alert.alertShow"
                show
                dismissible
                :variant="alert.alertVariant"
                >{{ alert.alertMsg }}</b-alert
              > -->
    <div class="row">
      <h3 class="card-title" style="text-decoration:underline;">
        Προσωπικά Στοιχεία Χρήστη
      </h3>
      <hr />
      <div class="col-12">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label> Username</label>
              <input
                v-model="userForm.user.username"
                type="text"
                required
                class="form-control"
                placeholder="Username"
                disabled
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label> Hrms Χρήστη</label>
              <input
                v-model="userForm.hrms_person_id"
                type="text"
                required
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label>Όνομα*</label>
          <input
            v-model="userForm.user.first_name"
            required
            type="text"
            class="form-control"
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label>Επίθετο*</label>
          <input
            v-model="userForm.user.last_name"
            required
            type="text"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="mb-3">
          <label>Πατρώνυμο*</label>
          <input
            v-model="userForm.fathers_name"
            required
            type="text"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <label>Μητρώνυμο*</label>
          <input
            v-model="userForm.mothers_name"
            required
            type="text"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <label>Email*</label>
          <input
            v-model="userForm.user.email"
            required
            type="email"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-2">
          <label>Τηλέφωνο Επικοινωνίας</label>
          <input v-model="userForm.phone" type="text" class="form-control" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-2">
          <label>Αριθμός Δελτίου Ταυτότητας</label>
          <input type="text" class="form-control" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-2">
          <label>Α.Φ.Μ.</label>
          <input type="text" class="form-control" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-2">
          <label>Α.Μ.Κ.Α.</label>
          <input type="text" class="form-control" />
        </div>
      </div>
    </div>

    <button
      v-if="!isError"
      class="btn btn-primary"
      @click.prevent="updateCurrentUser"
    >
      Ενημέρωση
    </button>
    <p v-if="errorMsgs" style="color:red">
      <strong>{{ errorMsgs }}</strong>
    </p>
  </div>
</template>

<script>
import session from "../../../../api/session";
import { eventCreate } from "../../../../eventspy.js";
export default {
  data() {
    return {
      userForm: [],
      isError: false,
      oldUserForm: [],
      errorMsgs: "",
    };
  },
  mounted() {
    this.fetchUpdatedPerson();
  },
  watch: {
    userForm: {
      handler(v) {
        if (isNaN(v.phone)) {
          this.errorMsgs = "Παρακαλώ μόνο αριθμούς";
          this.isError = true;
        } else if (v.phone.length > 15) {
          this.errorMsgs = "Παρακαλώ εισάγετε αριθμό τηλεφώνου ΟΧΙ iban";
          this.isError = true;
        } else {
          this.errorMsgs = "";
          this.isError = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    async fetchUpdatedPerson() {
      await session
        .get(`api/person/${this.$route.params.id}/update/`)
        .then((resp) => {
          this.userForm = resp.data;
          this.oldUserForm = resp.data;
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    async updateCurrentUser() {
      // Send message to browser screen

      await session
        .put(`api/person/${this.$route.params.id}/update/`, this.userForm)
        .then(() => {
          this.$toastr.Add({
            name: "UniqueToastName",
            title: `Ενημέρωση ${this.userForm.user.username}`,
            msg: "Τα προσωπικα στοιχεία του χρήστη ανανεώθηκαν επιτυχώς!",
            style: { backgroundColor: "#4fd69c", width: "550px" },
            progressbar: false,
            timeout: 2000,
          });
          this.fetchUpdatedPerson();
          eventCreate(
            `Επεξεργασία Προσωπικου :
            old =  ${JSON.stringify(this.oldUserForm)}
            ---------------------------------
            useform = ${JSON.stringify(this.userForm)}
             `,
            2
          );
        })
        .catch((e) => {
          console.log(e.response.data);
          this.$toastr.e(Object.values(e.response.data.user));
        });
    },
  },
};
</script>
